import React from "react";

// Lightweight markdown renderer: ## / ### headings, - lists, **bold**, paragraphs.
function renderInline(text) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**")) {
      return (
        <strong key={i} className="font-semibold text-ink">
          {p.slice(2, -2)}
        </strong>
      );
    }
    // italic *text*
    const italic = p.split(/(\*[^*]+\*)/g).map((seg, j) => {
      if (seg.startsWith("*") && seg.endsWith("*") && seg.length > 2) {
        return (
          <em key={j} className="italic">
            {seg.slice(1, -1)}
          </em>
        );
      }
      return <React.Fragment key={j}>{seg}</React.Fragment>;
    });
    return <React.Fragment key={i}>{italic}</React.Fragment>;
  });
}

export default function Markdown({ content = "" }) {
  const blocks = content.split(/\n\n+/);
  const out = [];
  let listBuffer = [];

  const flushList = (key) => {
    if (listBuffer.length) {
      out.push(
        <ul key={`ul-${key}`} className="list-disc pl-6 space-y-2 text-ink-muted">
          {listBuffer.map((li, i) => (
            <li key={i}>{renderInline(li)}</li>
          ))}
        </ul>
      );
      listBuffer = [];
    }
  };

  blocks.forEach((block, idx) => {
    const trimmed = block.trim();
    if (trimmed.startsWith("### ")) {
      flushList(idx);
      out.push(
        <h3 key={idx} className="font-serif text-2xl md:text-3xl text-ink mt-8">
          {renderInline(trimmed.slice(4))}
        </h3>
      );
    } else if (trimmed.startsWith("## ")) {
      flushList(idx);
      out.push(
        <h2 key={idx} className="font-serif text-3xl md:text-4xl text-ink mt-10 mb-2">
          {renderInline(trimmed.slice(3))}
        </h2>
      );
    } else if (/^-\s/.test(trimmed)) {
      trimmed.split("\n").forEach((line) => {
        if (/^-\s/.test(line.trim())) listBuffer.push(line.trim().slice(2));
      });
    } else {
      flushList(idx);
      out.push(
        <p key={idx} className="text-lg leading-relaxed text-ink-muted">
          {renderInline(trimmed)}
        </p>
      );
    }
  });
  flushList("end");

  return <div className="space-y-5">{out}</div>;
}
